import { Inject, Injectable } from '@angular/core';
import { IEnvironmentConfiguration } from './i-environment.configuration';

export const ENVIRONMENT_CONFIGURATION_VARIABLE = 'environmentConfigurationVariable';
export const RELEASE_VERSION_CONFIGURATION_VARIABLE = 'releaseVersionConfigurationVariable';

@Injectable()
export class EnvironmentConfigurationService {
  public constructor(
    @Inject(ENVIRONMENT_CONFIGURATION_VARIABLE) private readonly environmentConfigurationVariable,
    @Inject(RELEASE_VERSION_CONFIGURATION_VARIABLE) private readonly releaseVersionConfigurationVariable,
  ) {}

  public get configurationSettings(): IEnvironmentConfiguration {
    const config = (window as any)[this.environmentConfigurationVariable];
    config.releaseVersion = (window as any)[this.releaseVersionConfigurationVariable]?.releaseVersion;

    return config;
  }
}
